module.exports = __webpack_public_path__ + "img/rimagLogo.2cd94f42.png";